import { useRoleContext } from "hooks";

import { CarrierShipmentQATab } from "../../../Carrier/components/CarrierShipmentQA";
import { ShipperShipmentQATab } from "../../../Shipper/components/ShipperShipmentQATab";

interface Props {
  shipment: CondensedShipment | undefined;
}

export function ShipmentQATab(props: Props) {
  const { shipment } = props;
  const { role } = useRoleContext();

  if (role?.type === "CARRIER") {
    return (
      <CarrierShipmentQATab shipment={shipment as CarrierCondensedShipment} />
    );
  }
  if (role?.type === "SHIPPER") {
    return <ShipperShipmentQATab shipment={shipment} />;
  }

  return <p>No valid role found</p>;
}
